import "./ChemicalProcessingCaseStudy.module.css";
import Header from "@/reusable_sections/Header";
import Safety from "./sections/Safety";
import Chemicalprocessinghero from "./sections/Chemicalprocessinghero";
import Industrialcasestudydetail from "./sections/Industrialcasestudydetail";
import Footer from "@/reusable_sections/Footer";
export default function ChemicalProcessingCaseStudyPage() {
  return <div>
      <Header />
      
      
      <Safety />
      <Chemicalprocessinghero />
      <Industrialcasestudydetail />
      <Footer />
    </div>;
}